import type { NewsItem } from '@/types/media';

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: '《星海征途》票房突破20亿，国产科幻再创里程碑',
    category: '行业动态',
    date: '2025-10-15',
    source: '天堂影视快讯',
    summary:
      '上映三周，《星海征途》累计票房正式突破20亿元大关，成为今年国产科幻电影票房冠军，也刷新了同类影片的多项纪录。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Cinematic%20news%20article%20cover%20showing%20a%20glowing%20galaxy%20and%20a%20distant%20spacecraft%20deep%20navy%20and%20warm%20amber%20tones%20dramatic%20space%20atmosphere%20editorial%20photography%20no%20text&width=800&height=500&seq=ptv-news-01&orientation=landscape',
    relatedIds: [2, 3, 5],
    content: [
      '据发行方最新公布的数据，国产科幻电影《星海征途》自上映以来热度持续走高，上映第三周累计票房正式突破20亿元人民币，观影人次超过4600万，成为本年度截至目前票房最高的国产科幻影片。',
      '影片以近未来星际探索为背景，讲述「征途号」探索舰穿越未知星域的冒险故事。上映后，影片凭借扎实的世界观设定与细腻的人物刻画收获了大量好评，社交平台上关于剧情与结局的讨论持续升温。',
      '多位影评人认为，《星海征途》的成功不仅在于视效水准的突破，更在于它把宏大的科幻外壳与真实的情感内核结合起来，让观众在仰望星空的同时，也看见了人本身。',
      '发行方透露，影片的海外发行计划正在推进中，将在多个国家和地区陆续上映。同时，围绕影片世界观展开的衍生内容也在筹备当中。',
    ],
  },
  {
    id: 2,
    title: '悬疑剧《破晓行动》第二季正式官宣，原班人马回归',
    category: '新片推荐',
    date: '2025-10-13',
    source: '天堂影视编辑部',
    summary:
      '备受好评的悬疑剧《破晓行动》确认续订第二季，主创团队与原班主演阵容将悉数回归，预计明年春季与观众见面。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Neo-noir%20news%20article%20cover%20of%20a%20rainy%20city%20street%20at%20dawn%20with%20warm%20police%20lights%20reflecting%20on%20wet%20asphalt%20deep%20navy%20tones%20cinematic%20editorial%20mood%20no%20text&width=800&height=500&seq=ptv-news-02&orientation=landscape',
    relatedIds: [1, 4, 8],
    content: [
      '近日，备受观众好评的悬疑犯罪剧《破晓行动》正式官宣第二季。据出品方透露，第二季将继续由原班主创团队操刀，几位主演也将全部回归，延续上一季的故事脉络。',
      '第一季以专案组侦办连环案件为主线，凭借紧凑的节奏与对警察群体职业困境的深入刻画，在播出期间收获了大量讨论，多个话题登上热搜。',
      '制作方表示，第二季在案件设计上会进一步升级，同时将更深入地探讨主要角色在结案之后所面临的人生选择，力求在悬疑张力与人文关怀之间取得平衡。',
      '据悉，第二季目前已进入前期筹备阶段，预计将于明年春季开机并登陆各大平台，具体播出时间将在后续公布。',
    ],
  },
  {
    id: 3,
    title: '国际电影节获奖名单揭晓，多部华语影片入围主竞赛单元',
    category: '行业动态',
    date: '2025-10-11',
    source: '天堂影视快讯',
    summary:
      '本届国际电影节公布入围名单，多部华语影片成功跻身主竞赛单元，题材涵盖家庭、社会与历史等多个方向。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Elegant%20film%20festival%20news%20cover%20showing%20a%20red%20carpet%20and%20spotlights%20at%20night%20with%20warm%20amber%20and%20deep%20charcoal%20tones%20prestigious%20cinematic%20editorial%20mood%20no%20text&width=800&height=500&seq=ptv-news-03&orientation=landscape',
    relatedIds: [5, 7, 9],
    content: [
      '本届国际电影节日前公布了完整入围名单，多部华语影片成功跻身主竞赛单元，其中有作品聚焦家庭关系，也有作品关注社会现实与历史记忆，题材呈现多元化趋势。',
      '业内人士指出，近年来华语电影在国际舞台上愈发活跃，不仅在制作水准上不断精进，在叙事语言与文化表达上也形成了独特的辨识度，越来越多作品获得国际选片人的青睐。',
      '本届电影节评审团成员横跨多个国家与地区，其中包括多位知名导演与演员。评委会主席在开幕致辞中表示，希望电影能够成为不同文化之间沟通的桥梁。',
      '完整获奖名单将于电影节闭幕当晚公布，天堂影视将持续关注并带来最新报道。',
    ],
  },
  {
    id: 4,
    title: '《王座之争》最终季预告发布，粉丝期待值拉满',
    category: '新片推荐',
    date: '2025-10-09',
    source: '天堂影视编辑部',
    summary:
      '史诗奇幻剧《王座之争》发布最终季首支预告，震撼的战争场面与角色命运走向引发全球观众热烈讨论。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20news%20cover%20of%20a%20dramatic%20castle%20hall%20with%20torchlight%20and%20misty%20atmosphere%20deep%20indigo%20and%20warm%20amber%20tones%20grand%20cinematic%20editorial%20mood%20no%20text&width=800&height=500&seq=ptv-news-04&orientation=landscape',
    relatedIds: [1, 2, 8],
    content: [
      '史诗奇幻剧《王座之争》发布了最终季的首支预告片，短短两分钟的片段中，多场规模宏大的战争戏份与主要角色的命运走向逐一曝光，迅速在全球社交平台引发热议。',
      '作为近年来最具影响力的奇幻剧集之一，《王座之争》凭借庞大的世界观、多线并行的叙事结构与复杂立体的人物塑造积累了庞大的粉丝群体。最终季将把多条叙事线收束至高潮。',
      '制作方在预告发布后表示，最终季在视效与制作规模上都达到了整个系列的巅峰，同时对每个主要角色的结局都做了慎重安排，希望给一路追随的观众一个圆满的交代。',
      '最终季将于下月正式上线，天堂影视将持续跟进相关资讯与主创访谈。',
    ],
  },
  {
    id: 5,
    title: '暑期档观影指南：这十部新片值得走进影院',
    category: '新片推荐',
    date: '2025-10-06',
    source: '天堂影视编辑部',
    summary:
      '暑期档佳片云集，从科幻动作到温情剧情，我们精选了十部兼具口碑与观赏性的影片，供你安排观影清单。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Cinema%20auditorium%20with%20warm%20amber%20house%20lights%20and%20red%20seats%20soft%20glow%20of%20a%20screen%20in%20the%20distance%20cinematic%20editorial%20cover%20cozy%20atmosphere%20no%20text&width=800&height=500&seq=ptv-news-05&orientation=landscape',
    relatedIds: [1, 2, 4],
    content: [
      '随着暑期档拉开帷幕，院线迎来了一波新片上映高峰。从科幻动作到温情剧情，从国产佳作到海外引进，观众的选择比往年更加丰富。',
      '我们在综合了口碑、题材与观赏性之后，为大家精选了十部值得走进影院的影片，覆盖不同的观影偏好，无论是喜欢紧张刺激的观众，还是偏爱细腻情感的观众，都能找到适合自己的选择。',
      '其中既有像《星海征途》这样视效与情感兼备的大制作，也有《无声告白》这类以细腻笔触打动人心的文艺佳作。建议观众提前了解影片时长与分级信息，合理安排观影时间。',
      '温馨提示：热门场次建议提前线上购票，避免现场满座，影响观影体验。',
    ],
  },
  {
    id: 6,
    title: '影视行业回暖，流媒体平台内容投入创新高',
    category: '行业动态',
    date: '2025-10-03',
    source: '天堂影视快讯',
    summary:
      '最新行业报告显示，流媒体平台的原创内容投入持续增长，剧集与电影产能明显回升，行业整体呈现回暖态势。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Modern%20media%20production%20studio%20with%20camera%20equipment%20and%20warm%20set%20lighting%20teal%20and%20amber%20tones%20professional%20cinematic%20editorial%20cover%20no%20text&width=800&height=500&seq=ptv-news-06&orientation=landscape',
    relatedIds: [1, 3, 8],
    content: [
      '最新发布的行业报告显示，过去一年中主要流媒体平台在原创影视内容上的投入持续增长，创下近年来的新高。剧集与电影的年产能明显回升，行业整体呈现回暖态势。',
      '报告指出，观众对于高质量原创内容的付费意愿正在提升，这促使平台更加重视内容品质而非单纯的数量扩张。精品化、系列化成为当前内容生产的主要趋势。',
      '与此同时，制作技术的迭代也在改变行业面貌。虚拟拍摄、实时渲染等技术逐渐普及，使得中小成本作品也能呈现出接近大制作的视觉效果，为创作者提供了更多可能。',
      '业内普遍认为，随着内容供给的丰富与观众审美水平的提升，未来影视市场的竞争将更多聚焦于故事本身的质量与情感共鸣。',
    ],
  },
  {
    id: 7,
    title: '《樱花之约》导演谈创作：真挚的情感最能打动人心',
    category: '影讯',
    date: '2025-09-29',
    source: '天堂影视专访',
    summary:
      '在接受专访时，《樱花之约》导演中村悠介分享了影片的创作缘起，以及他对「等待」与「承诺」这两个主题的理解。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Serene%20Japanese%20riverside%20path%20lined%20with%20blooming%20sakura%20trees%20in%20soft%20spring%20light%20pink%20petals%20drifting%20gentle%20warm%20tones%20cinematic%20editorial%20cover%20no%20text&width=800&height=500&seq=ptv-news-07&orientation=landscape',
    relatedIds: [5, 9, 3],
    content: [
      '影片《樱花之约》自上映以来，凭借温柔克制的叙事收获了不少观众的喜爱。近日，导演中村悠介接受了我们的专访，分享了影片背后的创作故事。',
      '谈到创作缘起，中村悠介表示，影片的灵感来自他偶然看到的一张老照片——一对老人在同一棵树下连续多年拍下的合影。「那一刻我意识到，坚持本身就是一种了不起的情感表达。」',
      '对于影片中的「等待」与「承诺」两个主题，他坦言，现代社会节奏太快，人们习惯用效率衡量一切，而他希望通过这部电影，让观众重新感受时间沉淀下来的情感重量。',
      '当被问及对观众有什么期待时，中村悠介笑着说：「不需要太多，只要看完之后，愿意给某个人打个电话，就足够了。」',
    ],
  },
  {
    id: 8,
    title: '经典IP重启潮观察：情怀与创新如何平衡',
    category: '行业动态',
    date: '2025-09-25',
    source: '天堂影视编辑部',
    summary:
      '近年来越来越多经典影视IP被重启，情怀牌固然有效，但如何在致敬与创新之间找到平衡，成为创作者共同的课题。',
    thumbnail:
      'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20film%20reels%20and%20old%20projector%20on%20a%20wooden%20table%20with%20warm%20amber%20light%20soft%20dusty%20nostalgic%20tones%20cinematic%20editorial%20cover%20no%20text&width=800&height=500&seq=ptv-news-08&orientation=landscape',
    relatedIds: [4, 6, 2],
    content: [
      '近年来，影视行业掀起了一股经典IP重启的热潮。从剧集到电影，不少曾经陪伴一代人成长的作品以全新面貌回到观众视野，情怀牌成为市场上颇具号召力的卖点。',
      '然而，重启并非简单的翻拍。观众对原作往往有着深厚的情感记忆，任何改动都可能引发争议。如何在保留经典内核的同时注入新的时代表达，成为创作者必须面对的难题。',
      '多位从业者认为，成功的重启往往建立在对原作精神的深刻理解之上，而不是对经典桥段的机械复刻。真正打动人的，是作品与当下观众之间的情感连接。',
      '对于观众而言，情怀固然动人，但最终决定一部重启作品能否立住的，依然是它的故事质量与创作诚意。',
    ],
  },
];